module.exports = __webpack_public_path__ + "img/icon-arrow-left-2.ef6e56f8.svg";